/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'login';
const componentName = 'alb-login';
const prefix = `${moduleName}.${componentName}`;

export const usernameInputLabel = `${prefix}.usernameInputLabel`;
export const passwordInputLabel = `${prefix}.passwordInputLabel`;
export const forgotPassword = `${prefix}.forgotPassword`;
export const logIn = `${prefix}.logIn`;

export const ENGLISH = {
    [usernameInputLabel]: 'Username',
    [passwordInputLabel]: 'Password',
    [forgotPassword]: 'Forgot your password?',
    [logIn]: 'Log In',
};
